import { useEffect, useState, memo, useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { AddDeleteUpadate, fetchPostData } from '@/Components/hooks/Api';
import { toastifyError, toastifySuccess } from '@/Components/Common/AlertMsg';
import { AgencyContext } from 'Context/Agency';
import { threeColVictimOffenseArray, offenseArray, } from '@/Components/Common/ChangeArrayFormat';
import { get_LocalStoreData } from '@/redux/api';
import { Decrypt_Id_Name, isLockOrRestrictModule, tableCustomStyle } from '@/Components/Common/Utility';
import NameListing from '@/Components/Pages/ShowAllList/NameListing';
import DataTable from '@/Components/Common/DataTableWithAutoPagination';
const Offense = (props) => {

  const { DecNameID, DecMasterNameID, DecIncID, ListData, isLocked } = props
  const dispatch = useDispatch();
  const localStoreData = useSelector((state) => state.Agency.localStoreData);
  const uniqueId = sessionStorage.getItem('UniqueUserID') ? Decrypt_Id_Name(sessionStorage.getItem('UniqueUserID'), 'UForUniqueUserID') : '';

  const { get_Name_Count, setoffenceCountStatus, get_Data_Arrest, arrestFilterData } = useContext(AgencyContext);
  const [offenseDrp, setOffenseDrp] = useState();
  const [typeOfSecurityEditVal, setTypeOfSecurityEditVal] = useState();
  const [loginPinID, setLoginPinID,] = useState('');
  const [nameID, setNameID] = useState('');
  const [masterNameID, setmasterNameID] = useState('');
  const [incidentID, setIncidentID] = useState();
  const [multiSelected, setMultiSelected] = useState({ OffenseID: null, });
  const [selectedOffenses, setSelectedOffenses] = useState([]);

  useEffect(() => {
    if (!localStoreData?.AgencyID || !localStoreData?.PINID) {
      if (uniqueId) dispatch(get_LocalStoreData(uniqueId));
    }
  }, []);

  useEffect(() => {
    if (localStoreData) {
      setLoginPinID(localStoreData?.PINID);
    }
  }, [localStoreData]);

  useEffect(() => {
    if (DecNameID) {
      setNameID(DecNameID); setIncidentID(DecIncID);

    }
    else if (DecMasterNameID) {
      setmasterNameID(DecMasterNameID)
    }
  }, [DecNameID, loginPinID, DecMasterNameID]);


  useEffect(() => {
    if (DecNameID) {
      get_OffenseName_Data(DecNameID);
    }
  }, [DecNameID])

  useEffect(() => {
    if (incidentID) {
      get_Offense_DropDown(incidentID, DecNameID);
      get_Data_Arrest(incidentID, false, loginPinID);
    }
  }, [incidentID,])

  const get_OffenseName_Data = (DecNameID) => {
    const val = { 'NameID': DecNameID, }
    fetchPostData('NameOffense/GetData_NameOffense', val).then((res) => {
      if (res) {
        setTypeOfSecurityEditVal(offenseArray(res, 'NameOffenseID', 'OffenseID', 'NameID', 'NameID', 'Offense_Description', 'PretendToBeID'));
      } else {
        setTypeOfSecurityEditVal([]);
      }
    }).catch((err) => {
      console.error("🚀 ~ getOffenseData ~ err:", err);
    })
  }

  useEffect(() => {
    if (typeOfSecurityEditVal) {
      setMultiSelected(prevValues => { return { ...prevValues, OffenseID: typeOfSecurityEditVal } });
      // Update selectedOffenses to match typeOfSecurityEditVal
      // typeOfSecurityEditVal has: value = NameOffenseID, code = OffenseID
      // We need OffenseID (code) to match with offenseDrp.value (CrimeID/OffenseID)
      const selectedValues = typeOfSecurityEditVal.map(item => item.code);
      setSelectedOffenses(selectedValues);
    }
  }, [typeOfSecurityEditVal])

  const get_Offense_DropDown = (incidentID, nameID) => {
    const val = {
      'IncidentID': incidentID,
      'NameID': nameID,
      'MasterNameID': masterNameID,
      'IsMaster': nameID ? false : true
    }
    fetchPostData('NameOffense/GetData_InsertNameOffense', val).then((data) => {
      if (data) {
        setOffenseDrp(threeColVictimOffenseArray(data, 'CrimeID', 'Offense_Description'))
      } else {
        setOffenseDrp([])
      }
    }).catch((err) => {
      console.error("🚀 ~ get_Offense_DropDown fetchpostdata error ~ err:", err);
    })
  }

  const InSertBasicInfo = (id, col1, url) => {
    const val = {
      'NameID': nameID,
      [col1]: id,
      'CreatedByUserFK': loginPinID,
      'MasterNameID': masterNameID,
      'IsMaster': nameID ? false : true
    }
    AddDeleteUpadate(url, val).then((res) => {
      if (res) {
        const parsedData = JSON.parse(res.data);
        const message = parsedData.Table[0].Message;
        toastifySuccess(message);

        get_Name_Count(DecNameID)
        get_Offense_DropDown(incidentID, DecNameID);


        col1 === 'OffenseID' && get_OffenseName_Data(DecNameID);
      }
    }).catch((err) => {
      console.error("🚀 ~ Insert AddDeleteUpadate ~ err:", err);
    })
  }

  const DelSertBasicInfo = (OffenseID, col1, url) => {
    const val = {
      [col1]: OffenseID,
      'DeletedByUserFK': loginPinID,
    }
    AddDeleteUpadate(url, val).then((res) => {
      if (res) {
        const parsedData = JSON.parse(res.data);
        const message = parsedData.Table[0].Message;
        toastifySuccess(message);

        get_Name_Count(DecNameID)
        get_Offense_DropDown(incidentID, DecNameID);

        col1 === 'NameOffenseID' && get_OffenseName_Data(DecNameID)
      }
    }).catch((err) => {
      console.error("🚀 ~ Delete AddDeleteUpadate ~ err:", err);
    })
  }


  // Handle checkbox change for DataTable
  const handleCheckboxChange = (offenseId, isChecked) => {
    if (isChecked) {
      // Add to selected offenses immediately to remove from table
      setSelectedOffenses(prev => {
        if (prev.includes(offenseId)) return prev; // Already selected
        return [...prev, offenseId];
      });
      // Call insert API
      InSertBasicInfo(offenseId, 'OffenseID', 'NameOffense/Insert_NameOffense');
      setoffenceCountStatus(true);
    } else {
      // When unchecking last offense - block if nameID has arrest in arrestFilterData
      if (selectedOffenses.length <= 1) {
        const nameHasArrest = arrestFilterData?.some(item => parseInt(item.ArresteeID) === parseInt(nameID));
        if (nameHasArrest) {
          toastifyError("At least one offense should be selected as it is associated with Arrest.");
          return;
        }
      }
      // Remove from selected offenses immediately to show in table
      setSelectedOffenses(prev => {
        const remaining = prev.filter(id => id !== offenseId);
        if (remaining.length === 0) {
          setoffenceCountStatus(false);
        }
        return remaining;
      });
      // Find the NameOffenseID from typeOfSecurityEditVal
      // typeOfSecurityEditVal has: value = NameOffenseID, code = OffenseID
      const offenseToDelete = typeOfSecurityEditVal?.find(item => item.code === offenseId);
      if (offenseToDelete) {
        DelSertBasicInfo(offenseToDelete.value, 'NameOffenseID', 'NameOffense/Delete_NameOffense');
      }
    }
  };

  // Define columns for DataTable
  const columns = [
    {
      name: '',
      width: '60px',
      cell: (row) => (
        <input
          type="checkbox"
          checked={selectedOffenses.includes(row.value)}
          onChange={(e) => handleCheckboxChange(row.value, e.target.checked)}
          disabled={isLockOrRestrictModule("Lock", typeOfSecurityEditVal, isLocked, true)}
          style={{ cursor: isLockOrRestrictModule("Lock", typeOfSecurityEditVal, isLocked, true) ? 'not-allowed' : 'pointer' }}
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: 'Offense',
      selector: (row) => row.label,
      sortable: true,
      wrap: true,
    },
  ];

  // Combine offenseDrp with multiSelected offenses to show all offenses
  // Convert multiSelected.OffenseID items to match offenseDrp format
  const multiSelectedOffenses = (multiSelected?.OffenseID || []).map(item => ({
    value: item.code, // OffenseID
    label: item.label, // Offense_Description
    isFromMultiSelected: true // Flag to identify source
  }));

  // Merge offenseDrp and multiSelected offenses, removing duplicates
  const allOffenses = [...(offenseDrp || [])];
  multiSelectedOffenses.forEach(multiOffense => {
    // Check if offense already exists in offenseDrp
    const existingIndex = allOffenses.findIndex(off => off.value === multiOffense.value);
    if (existingIndex !== -1) {
      // Update existing item to mark it as from multiSelected
      allOffenses[existingIndex].isFromMultiSelected = true;
    } else {
      // Add new item from multiSelected
      allOffenses.push(multiOffense);
    }
  });

  // Sort: items with isFromMultiSelected=true at top, then alphabetically by label
  const sortedAllOffenses = allOffenses.sort((a, b) => {
    // First, prioritize items from multiSelected (isFromMultiSelected: true)
    if (a.isFromMultiSelected && !b.isFromMultiSelected) return -1;
    if (!a.isFromMultiSelected && b.isFromMultiSelected) return 1;

    // If both have same isFromMultiSelected status, sort alphabetically by label
    const labelA = a.label?.toLowerCase() || '';
    const labelB = b.label?.toLowerCase() || '';
    return labelA.localeCompare(labelB);
  });

  return (
    <>
      <NameListing {...{ ListData }} />
      <div className="col-12 " id='display-not-form'>
        <div className='row'>
          <label htmlFor="" className='label-name ' style={{ fontSize: "15px" }}>Please Select the Offense Associate with this Person</label>
        </div>
        <div className="row  mt-2">
          <div className="col-12 mb-3" >
            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
              <DataTable
                columns={columns}
                data={sortedAllOffenses}
                customStyles={{
                  ...tableCustomStyle,
                  tableWrapper: {
                    style: {
                      maxHeight: '300px',
                    },
                  },
                }}
                noDataComponent="No offenses available"
                dense
                highlightOnHover
                fixedHeader
                fixedHeaderScrollHeight="300px"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default memo(Offense)